import { TypeBase } from "../../Generator/src/generators/validationGenerator/Nodes/TypeNode";

export type RngSchemeTypes = TypeBase | "dateTime" | "int" | "double";
